import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3c2beb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-table-bordered" }
const _hoisted_2 = { class: "ant-table-tbody" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"60px"} }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"150px"} }, "总计", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"150px"} }, null, -1))
const _hoisted_6 = { style: {"width":"200px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"250px"} }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"150px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    size: "small",
    class: "payment-detail-table"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_table, {
        "row-key": "id",
        size: "small",
        bordered: true,
        "data-source": _ctx.data?.receiptWriteenOffDetailQueryAResps,
        columns: _ctx.columns,
        scroll: { x: true },
        pagination: false
      }, {
        index: _withCtx(({ index }) => [
          _createTextVNode(_toDisplayString(index + 1), 1)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("tr", null, [
                _hoisted_3,
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$filters.formatMoney(_ctx.currentCollectionTotalPrice)), 1),
                _hoisted_7,
                _hoisted_8
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["data-source", "columns"])
    ]),
    _: 1
  }))
}